export enum IFrameParentMessageType {
    generic = 'BIOLIB_IFRAME_RESPONSE',
    jobProgress = 'BIOLIB_IFRAME_RESPONSE_jobProgress',
    triggerResize = 'BIOLIB_IFRAME_REQUEST_triggerResize',
    utilFunctionInvocation = 'BIOLIB_IFRAME_PARENT_utilFunctionInvocation',
    utilFunctionResponse = 'BIOLIB_IFRAME_PARENT_utilFunctionResponse',
}

export enum IFrameRequestType {
    createExperiment = 'BIOLIB_IFRAME_REQUEST_createExperiment',
    createResultNote = 'BIOLIB_IFRAME_REQUEST_createResultNote',
    fetch = 'BIOLIB_IFRAME_REQUEST_fetch',
    getExperiment = 'BIOLIB_IFRAME_REQUEST_getExperiment',
    getFileDataFromDataRecord = 'BIOLIB_IFRAME_REQUEST_getFileDataFromDataRecord',
    getIndex = 'BIOLIB_IFRAME_REQUEST_getIndex',
    getInputFileData = 'BIOLIB_IFRAME_REQUEST_getInputFileData',
    getResult = 'BIOLIB_IFRAME_REQUEST_getResult',
    getOAuthAccessToken = 'BIOLIB_IFRAME_REQUEST_getOAuthAccessToken',
    getOutputFileData = 'BIOLIB_IFRAME_REQUEST_getOutputFileData',
    iframeReady = 'BIOLIB_IFRAME_REQUEST_iframeReady',
    keyboardShortcut = 'BIOLIB_IFRAME_REQUEST_keyboardShortcut',
    listExperimentResults = 'BIOLIB_IFRAME_REQUEST_listExperimentResults',
    listExperiments = 'BIOLIB_IFRAME_REQUEST_listExperiments',
    listOutputFilePaths = 'BIOLIB_IFRAME_REQUEST_listOutputFilePaths',
    listResultNotes = 'BIOLIB_IFRAME_REQUEST_listResultNotes',
    openUrl = 'BIOLIB_IFRAME_REQUEST_openUrl',
    getResultOutputFileInfo = 'BIOLIB_IFRAME_REQUEST_getResultOutputFileInfo',
    getResultOutputFileData = 'BIOLIB_IFRAME_REQUEST_getResultOutputFileData',
    streamResultLogs = 'BIOLIB_IFRAME_REQUEST_streamResultLogs',
    queryIndex = 'BIOLIB_IFRAME_REQUEST_queryIndex',
    resizeIframe = 'BIOLIB_IFRAME_REQUEST_resizeIframe',
    runJob = 'BIOLIB_IFRAME_REQUEST_runJob',
}

export interface IFrameRequest {
    iframeId: string;
    payload: object;
    requestId: string;
    type: IFrameRequestType;
}

export interface IResponsePayload {
    error?: any;
    result?: any;
}

export interface IFrameParentMessage {
    requestId?: string;
    type: IFrameParentMessageType;
    payload?: any;
}

export interface IFileInIframe {
    path: string;
    type: 'input' | 'output';
    viewRaw: boolean;
}
